import React, { memo } from 'react';
import { Link } from 'react-router-dom';

type WrapperProps = {
  to: string;
  children?: React.ReactNode;
  asLink: boolean;
  className: string;
  onClick: Function;
};

function FeedItemWrapper({ children, asLink, ...otherProps }: WrapperProps) {
  if (asLink) return <Link {...otherProps}>{children}</Link>;

  return <div className={otherProps.className}>{children}</div>;
}

export default memo(FeedItemWrapper);
